export const SALES_ACCESS_RESTRICTED_TEST_IDS = {
  container: 'sales-access-restricted-container',
  stepsTitle: 'sales-access-restricted-steps-title',
  steps: 'sales-access-restricted-steps',
  cidmLink: 'sales-access-restricted-cidm-link',
  returnLink: 'sales-access-restricted-return-link',
};
